import { createSlice } from "@reduxjs/toolkit";
export const addBranchSlice = createSlice({
	name: "addBranches",
	initialState: {
		branchProfile: {
			operatorId: localStorage.getItem("user")
				? JSON.parse(localStorage.getItem("user")).operator_id
				: null,
			branchLevel: 1,
			partnerId: "",
			partnerBranch: "",
			address: "",
			contactPerson: "",
			contactPerson2: "",
			contactPosition: "",
			contactPosition2: "",
			zipCode: "",
			landline: "",
			landline2: "",
			mobile: "",
			mobile2: "",
			email: "",
			email2: "",
			remarks: "",
			// branchStatus: "",
			// statusComments: "",
		},
		partnerList: [],
	},
	reducers: {
		getPartnerList: (state, actions) => {
			state.partnerList = actions.payload;
		},
		handleOnChangeReducer: (state, actions) => {
			switch (actions.payload.name) {
				case "partnerId":
					return {
						...state,
						branchProfile: {
							...state.branchProfile,
							partnerId: actions.payload.value,
						},
					};
				case "branchLevel":
					return {
						...state,
						branchProfile: {
							...state.branchProfile,
							branchLevel: actions.payload.checked ? 0 : 1,
						},
					};
				case "partnerBranch":
					return {
						...state,
						branchProfile: {
							...state.branchProfile,
							partnerBranch: actions.payload.value,
						},
					};
				case "address":
					return {
						...state,
						branchProfile: {
							...state.branchProfile,
							address: actions.payload.value,
						},
					};
				case "zipCode":
					// Validate the zip code using the regex pattern
					const zipCodeRegex = /^(?:[0-9]*)$/;
					const isValidZipCode = zipCodeRegex.test(actions.payload.value);

					if (!isValidZipCode) {
						// If the zip code is invalid, you can handle it accordingly (e.g., show an error message)
						return {
							...state, // Keep the current state
							error: "Invalid zip code", // Add an error message
						};
					}

					// If the zip code is valid, update the state
					return {
						...state,
						branchProfile: {
							...state.branchProfile,
							zipCode: actions.payload.value,
						},
						error: null, // Clear any previous error message
					};
				case "branchStatus":
					return {
						...state,
						branchProfile: {
							...state.branchProfile,
							branchStatus: actions.payload.value,
						},
					};
				case "statusComments":
					return {
						...state,
						branchProfile: {
							...state.branchProfile,
							statusComments: actions.payload.value,
						},
					};
				case "contactPerson":
					return {
						...state,
						branchProfile: {
							...state.branchProfile,
							contactPerson: actions.payload.value,
						},
					};
				case "contactPerson2":
					return {
						...state,
						branchProfile: {
							...state.branchProfile,
							contactPerson2: actions.payload.value,
						},
					};
				case "contactPosition":
					return {
						...state,
						branchProfile: {
							...state.branchProfile,
							contactPosition: actions.payload.value,
						},
					};
				case "contactPosition2":
					return {
						...state,
						branchProfile: {
							...state.branchProfile,
							contactPosition2: actions.payload.value,
						},
					};
				case "mobile":
					const regexMobile = /^[0-9]+$/;
					const isValidMobile = regexMobile.test(actions.payload.value);
					if (!isValidMobile) {
						// If the zip code is invalid, you can handle it accordingly (e.g., show an error message)
						return {
							...state, // Keep the current state
							error: "Invalid", // Add an error message
						};
					}

					// If the zip code is valid, update the state
					return {
						...state,
						branchProfile: {
							...state.branchProfile,
							mobile: actions.payload.value,
						},
						error: null, // Clear any previous error message
					};
				case "mobile2":
					const regexMobile2 = /^[0-9]+$/;
					const isValidMobile2 = regexMobile2.test(actions.payload.value);
					if (!isValidMobile2) {
						// If the zip code is invalid, you can handle it accordingly (e.g., show an error message)
						return {
							...state, // Keep the current state
							error: "Invalid", // Add an error message
						};
					}

					// If the zip code is valid, update the state
					return {
						...state,
						branchProfile: {
							...state.branchProfile,
							mobile2: actions.payload.value,
						},
						error: null, // Clear any previous error message
					};
				case "landline":
					const regexLandline = /^[0-9]+$/;
					// const isValidLandline = regexLandline.test(actions.payload.value);
					// if (!isValidLandline) {
					//   // If the zip code is invalid, you can handle it accordingly (e.g., show an error message)
					//   return {
					//     ...state, // Keep the current state
					//     error: "Invalid", // Add an error message
					//   };
					// }

					// If the zip code is valid, update the state
					return {
						...state,
						branchProfile: {
							...state.branchProfile,
							landline: actions.payload.value,
						},
						error: null, // Clear any previous error message
					};
				case "landline2":
					const regexLandline2 = /^[0-9]+$/;
					// const isValidLandline2 = regexLandline2.test(actions.payload.value);
					// if (!isValidLandline2) {
					//   // If the zip code is invalid, you can handle it accordingly (e.g., show an error message)
					//   return {
					//     ...state, // Keep the current state
					//     error: "Invalid", // Add an error message
					//   };
					// }

					// If the zip code is valid, update the state
					return {
						...state,
						branchProfile: {
							...state.branchProfile,
							landline2: actions.payload.value,
						},
						error: null, // Clear any previous error message
					};
				case "email":
					return {
						...state,
						branchProfile: {
							...state.branchProfile,
							email: actions.payload.value,
						},
					};
				case "email2":
					return {
						...state,
						branchProfile: {
							...state.branchProfile,
							email2: actions.payload.value,
						},
					};
				case "remarks":
					return {
						...state,
						branchProfile: {
							...state.branchProfile,
							remarks: actions.payload.value,
						},
					};
				default:
					return state;
			}
		},
		clearBranchProfile: (state) => {
			state.branchProfile = {
				// Keep the operatorId from localStorage
				operatorId: localStorage.getItem("user")
					? JSON.parse(localStorage.getItem("user")).operator_id
					: null,
				branchLevel: 1,
				partnerId: "",
				partnerBranch: "",
				address: "",
				contactPerson: "",
				contactPerson2: "",
				contactPosition: "",
				contactPosition2: "",
				zipCode: "",
				landline: "",
				landline2: "",
				mobile: "",
				mobile2: "",
				email: "",
				email2: "",
				remarks: "",
			};
		},
	},
});

// Action creators are generated for each case reducer function
export const {
	getBranchProfile,
	getPartnerList,
	handleOnChangeReducer,
	clearBranchProfile,
} = addBranchSlice.actions;

export default addBranchSlice.reducer;

// "operatorId": 2,
// "partnerBranchId": 37,
// "branchLevel": 1,
// "partnerId": 70,
// "partnerBranch": "Super Special Branch",
// "address": "8700 Jollibee Delivery",
// "contactPerson": "John Allicel Licerio",
// "contactPerson2": "Fritz Salindong",
// "contactPosition":"Operation Manager" ,
// "contactPosition2": "Marketing Manager",
// "landline": "00978612",
// "landline2": "00978612",
// "mobile": "63929300635",
// "mobile2": "639293006635",
// "email": "ops.coordinator@mbox.com.ph",
// "email2": "fritz.salindong@mbox.com.ph",
// "remarks": "This branch for the samples",
// "statusComments": "Active because it need for the samples",
//  "zipCode":3015,
// "branchStatus": 1,
// "loadBalance": 127.6
